import axios from "axios";

export const apiUrl = `https://apipainel.sysprojud.com`;
// export const apiUrl = `http://localhost:4321`;

export const apiSpjUrl = `https://api.sysprojud.com`;
// export const apiSpjUrl = `http://localhost:1234`;

export const api = axios.create({
    baseURL: apiUrl,
});

export const apiSpj = axios.create({
    baseURL: apiSpjUrl,
});

api.interceptors.request.use(config => {
    const infoLogin = JSON.parse(String(sessionStorage.getItem("infoLogin")));
    config.headers.token = (infoLogin && infoLogin.token) ? infoLogin.token : '';
    return config;
});